import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { AdminSidebarApi, OtherRoleSidebarApi, SuperAdminSidebarApi } from './SideBarApi';
import SideBarMenu from './SideBarMenu';
import Swal from "sweetalert2";
import NavSettings from '../Navbar/NavSettings';
import "../Sidebar/SideBar.css";
import { setLogin, setUserDetails,resetCallState } from '../../Redux/Slice/LoginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { environment } from '../../API/env';
import default_logo from '../../assets/Images/default_logo.png';
import { IconExclamationCircle ,IconChevronLeft } from "@tabler/icons-react";
import { renderToString } from "react-dom/server";
import { persistor } from '../../Redux/store';


export default function SideBar({ children }) {
    const userDetails = useSelector(state => state?.login?.userDetails)    
    const [value, setValue] = useState(false);
    const [mobileSidebar, setMobileSidebar] = useState(false);
    const [isActiveLink, setIsActiveLink] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const logoImagesURL = userDetails?.company?.companyLogoUrl 
    ? `${environment?.image_base_url}/${userDetails?.company?.companyLogoUrl}` 
    : default_logo;

const nLogout = () => {
  Swal.fire({
    html: `
      <div class="flex flex-col items-center gap-2 -mt-4">

        <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
          ${renderToString(<IconExclamationCircle size={64} color="#F59E0B" />)}
        </div>

        <h2 class="text-[32px] font-bold text-[#4A5565] leading-[140%] font-[Nata Sans]">
          Warning
        </h2>

        <p class="text-[24px] font-medium text-[#4A5565] leading-[140%] font-[Nata Sans]">
          Would you like to logout
        </p>

      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    buttonsStyling: false,

    customClass: {
      popup: "rounded-xl px-6 py-4",
      actions: "flex justify-center gap-4 mt-2",

      confirmButton:
        "w-[100px] h-[48px] text-white rounded-[4px] flex items-center justify-center bg-[var(--bg-base-color)]",

      cancelButton:
        "w-[100px] h-[48px] bg-white rounded-[4px] flex items-center justify-center border text-[var(--bg-base-color)]",
    },
  }).then(async ({ isConfirmed }) => {
    if (isConfirmed) {
      dispatch(setLogin(false));
      dispatch(setUserDetails([]));
      dispatch(resetCallState());
      await persistor.flush();
      await persistor.purge();
      localStorage.removeItem("persist:CRM-Dashboard");
      localStorage.removeItem("RefreshToken");
      localStorage.removeItem("Token");
      localStorage.removeItem("themeColor");
      navigate("");
    }
  });
};
    return (
        <>

            <div className="">
                {mobileSidebar && <div className="fixed top-0 bottom-0 left-0 right-0 z-50 w-full h-screen" onClick={() => setMobileSidebar(!mobileSidebar)} />}
                <div className='' >
                    <div className={`${isActiveLink ? "w-[5.3rem]" : "w-[19rem]"} bg-white h-full z-[300]  duration-700 lg:block  transition-all ease-in-out top-0 left-0 fixed shadow-lg ${mobileSidebar ? "block z-[300]" : "hidden"}`}>
                        <div className="absolute -right-4 top-[5.7rem] hidden lg:block">
                            <button
                                onClick={() => setIsActiveLink(!isActiveLink)}
                                className="bg-[#f3f3f3] hover:bg-[var(--bg-base-color)] group p-2 rounded-full shadow-md transition-all duration-300"
                            >
                                <IconChevronLeft
                                    className={`text-[var(--bg-base-color)] transition-all duration-500 group-hover:text-white ${isActiveLink ? "rotate-180" : ""}`}
                                    size={22}
                                />
                            </button>
                        </div>
                        <div className="flex justify-center items-center gap-3 flex-col">
                            <div
                                className={
                                    isActiveLink
                                    ? "px-3 py-1 transition-all duration-700"
                                    : "px-5 py-3 transition-all duration-700"
                                }
                                >
                                { isActiveLink ? (
                                    <>
                                        <div className={`w-14 h-14 rounded-full border-2 flex items-center justify-center bg-[var(--bg-base-color)] m-2 `} >
                                            <p className="text-[#FFFFFF]  font-bold text-lg">
                                            { userDetails?.company?.companyName.slice(0, 1)}
                                            </p>
                                        </div>
                                    </>
                                    ):(
                                        <>
                                            <img
                                                src={logoImagesURL}
                                                className="block object-contain w-[180px] h-auto transition-all duration-700 rounded-md"
                                            />
                                        </>   
                                )}
                            </div>
                            <div className="text-center">
                                {!isActiveLink && (
                                    <h4 className="base-font-muli fw-bold text-nowrap text-capitalize fs-5 mb-0 text-base-color mt-[-20px]">
                                        {userDetails?.company?.companyName}
                                    </h4>
                                )}
                                <div className={`${value ? "lines-border " : "lines"}`}></div>
                            </div>
                        </div>

                        <div className=" flex flex-col gap-1 overflow-scroll sidebarScroll sidebar-tabs">
                            {
                                userDetails?.role?.roleName == "SuperAdmin" ?
                                    <>
                                        {SuperAdminSidebarApi()?.map((curElm, i) => {
                                            if (curElm.childs) {
                                                return (
                                                    <SideBarMenu key={i} curElm={curElm} isActiveLink={isActiveLink}/>
                                                );
                                            }
                                            return (
                                                <NavLink
                                                    to={curElm.link}
                                                    key={i}
                                                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""} ${!isActiveLink ? "pl-3 pr-4 justify-between" : "justify-center"}` }
                                                >
                            
                                                    <span className="d-flex ml-[1px] gap-2 align-items-center">
                                                        <span className="">
                                                            {curElm.icon}
                                                        </span>
                                                       {!isActiveLink && <h5 className="mb-0 title-font-700 fs-5 base-font-muli fw-bold"> {curElm.title} </h5>}
                                                    </span>
                                                </NavLink>
                                            );
                                        })}
                                    </> : userDetails?.role?.roleName == "Admin" ?
                                        <>
                                            {AdminSidebarApi()?.map((curElm, i) => {
                                                if (curElm.childs) {
                                                    return (
                                                        <SideBarMenu key={i} curElm={curElm} isActiveLink={isActiveLink} />
                                                    );
                                                }
                                                return (
                                                    <NavLink
                                                        to={curElm.link}
                                                        key={i}
                                                        className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""} ${!isActiveLink ? "pl-3 pr-4 justify-between" : "justify-center"}`}
                                                    >
                                                     
                                                        <span className="d-flex gap-2 align-items-center">
                                                            <span className="">
                                                                {curElm.icon}
                                                            </span>
                                                            {!isActiveLink && <h5 className="mb-0 title-font-700 fs-5 base-font-muli fw-bold"> {curElm.title} </h5>}
                                                        </span>
                                                    </NavLink>
                                                );
                                            })}
                                        </> :
                                        <>
                                        {OtherRoleSidebarApi()?.map((curElm, i) => {
                                                if (curElm.childs) {
                                                    return (
                                                        <SideBarMenu key={i} curElm={curElm} isActiveLink={isActiveLink} />
                                                    );
                                                }
                                                return (
                                                    <NavLink
                                                        to={curElm.link}
                                                        key={i}
                                                        className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""} ${!isActiveLink ? "pl-3 pr-4 justify-between" : "justify-center"}`}
                                                    >
                                                   
                                                        <span className="flex gap-2 items-center">
                                                            <span className="">
                                                                {curElm.icon}
                                                            </span>
                                                            {!isActiveLink &&<h5 className="mb-0 title-font-700 fs-5 base-font-muli fw-bold"> {curElm.title} </h5>}
                                                        </span>
                                                    </NavLink>
                                                );
                                            })}
                                        </>
                            }
                        </div>
                    </div>
                </div>
                <div className={isActiveLink ? "transition-all duration-500 sm:ml-[1rem] md:ml-[1rem] lg:ml-[-15rem] " : "transition-all duration-500"} >
                    {/* ====================== Navbar start ===================== */}
                    <NavSettings nLogout={nLogout} setMobileSidebar={setMobileSidebar} mobileSidebar={mobileSidebar} />
                    {/* ====================== sidebar end ===================== */}
                    <main className="pb-5" >
                        {/* ====================== Routes start ===================== */}
                        {children}
                        {/* ======================Routes start ===================== */}
                    </main>
                </div>
            </div>
        </>
    )
}